<template>
  <Loading :loading="loading">
    <div>
      <NavBar :isShowLeft="false"></NavBar>
      <div class="c-effui6" v-if="!queryResult">
        <div class="c-effui6-title">人员信息</div>
        <van-form ref="form" @submit="onSubmit">
          <div class="form">
            <div class="flex-row margin-bottom flex-align-center">
              <span class="c-8moxqg-item-star">*</span>
              <div class="c-8moxqg-item-label">姓名:</div>
              <div class="c-8moxqg-item-value">
                <van-field
                  v-model="name"
                  name="name"
                  placeholder="请输入姓名"
                  class="c-8moxqg-item-value-text"
                  :rules="[{ required: true, message: '请输入姓名' }]"
                />
              </div>
            </div>
            <div class="flex-row margin-bottom flex-align-center">
              <span class="c-8moxqg-item-star">*</span>
              <div class="c-8moxqg-item-label">证件号码:</div>
              <div class="c-8moxqg-item-value">
                <van-field
                  v-model="idNo"
                  name="idNo"
                  class="c-8moxqg-item-value-text"
                  placeholder="请输入证件号码"
                  :rules="cardNoeRules"
                />
              </div>
            </div>
          </div>
          <van-button class="button" type="primary" native-type="submit">
            查询
          </van-button>
        </van-form>
      </div>
      <div class="c-effui6-1" v-else>
        <!-- <div class="c-effui6-title">查询结果</div> -->
        <van-form ref="resultForm" @submit="onResultSubmit">
          <div class="form">
            <div style="text-align: center">
              <van-image
                width="4rem"
                :src="result.idphotoURL"
              />
            </div>
            
            <div class="flex-row margin-bottom flex-align-center">
              <div class="c-8moxqg-item-label">结业证编号:</div>
              <div class="c-8moxqg-item-value">
                <van-field
                  v-model="result.certificateNo"
                  name="certificateNo"
                  class="c-8moxqg-item-value-text"
                  readonly
                />
              </div>
            </div>
            <div class="flex-row margin-bottom flex-align-center">
              <div class="c-8moxqg-item-label">姓名:</div>
              <div class="c-8moxqg-item-value">
                <van-field
                  v-model="result.name"
                  name="name"
                  class="c-8moxqg-item-value-text"
                  readonly
                />
              </div>
            </div>
            <div class="flex-row margin-bottom flex-align-center">
              <div class="c-8moxqg-item-label">证件号码:</div>
              <div class="c-8moxqg-item-value">
                <van-field
                  v-model="result.idNo"
                  name="idNo"
                  class="c-8moxqg-item-value-text"
                  readonly
                />
              </div>
            </div>
            <div class="flex-row margin-bottom flex-align-center">
              <div class="c-8moxqg-item-label">培训期数:</div>
              <div class="c-8moxqg-item-value">
                <van-field
                  v-model="result.periods"
                  name="periods"
                  class="c-8moxqg-item-value-text"
                  readonly
                />
              </div>
            </div>
            <div class="flex-row margin-bottom flex-align-center">
              <div class="c-8moxqg-item-label">培训时间:</div>
              <div class="c-8moxqg-item-value">
                <van-field
                  v-model="result.timeSlot"
                  name="timeSlot"
                  class="c-8moxqg-item-value-text"
                  readonly
                />
              </div>
            </div>
            <div class="flex-row margin-bottom flex-align-center">
              <div class="c-8moxqg-item-label">成绩:</div>
              <div class="c-8moxqg-item-value">
                <van-field
                  v-model="result.result"
                  name="result"
                  class="c-8moxqg-item-value-text"
                  readonly
                />
              </div>
            </div>
          </div>
          <van-button class="button" type="primary" native-type="submit">
            返回
          </van-button>
        </van-form>
      </div>
    </div>
  </Loading>
</template>
<script>
import NavBar from '@/components/h5header'
import API from '@/services/h5/common'
import Loading from '@/components/data-loading'
export default {
  components: { Loading, NavBar },
  data() {
    return {
      name: '',
      idNo: '',
      queryResult: false,
      loading: false,
      cardNoeRules: [
          { required: true, message: '请输入证件号码' },
          // {
          //   validator: value => {
          //     if (value.length == 15) {
          //       return true
          //     } else if (value.length == 18) {
          //       return true
          //     } else {
          //       return false
          //     }
          //   },
          //   message: '请输入正确的身份证号'
          // }
        ],
      result: {
        name: undefined,
        idNo: undefined,
        periods: undefined,
        timeSlot: undefined,
        result: undefined,
        certificateNo: undefined,
        idphotoURL: undefined,
      },  
    }
  },
  created() {
    
  },
  mounted() {
  },
  methods: {
    async onSubmit(values) {
      let that = this
      this.$refs.form
        .validate()
        .then(() => {
          console.log(values)
          API.getClaimBrokerAuthentication(values).then((res) => {
            if (res && res.data && res.data.code === 1000) {
              for (let key in that.result) {
                that.result[key] = res.data.data[key]
              }
              this.queryResult = true
            }
          })
        })
        .catch(() => {})
    },
    onResultSubmit(values) {
      console.log(values)
      this.queryResult = false
    }
  }
}
</script>
<style scoped lang="less">
.c-effui6 {
  position: absolute;
  top: 60px;
  left: 15px;
  &-title {
    font-size: 19px;
    font-weight: bold;
    color: @c-color-primary;
  }
}
.c-effui6-1 {
  position: absolute;
  top: 0;
  left: 15px;
  &-title {
    font-size: 19px;
    font-weight: bold;
    color: @c-color-primary;
  }
}
.form {
  padding: 10px;
  background-color: #fff;
  border-radius: 13px;
}
.c-8moxqg-item {
  &-star {
    color: red;
    font-size: 15px;
  }
  &-label {
    width: 80px;
    font-size: 15px;
    color: #333;
    text-align: justify;
    text-align-last: justify;
  }
  &-value {
    flex: 1;
    /deep/.van-field--error .van-field__control::placeholder {
      color: #999;
    }
  }
  &-value-text {
    font-size: 15px;
    color: #333;
    text-align: left;
  }
  &-margin-left {
    margin-left: 15px;
  }
  &-value-text-active {
    /deep/.van-field__control:disabled {
      color: #333;
      -webkit-text-fill-color: #333;
    }
  }
  &-left {
    font-size: 16px;
    color: #999;
  }
  &-img {
    width: 15px;
    height: 15px;
  }
  &-scan {
    color: @c-color-primary;
    font-size: 16px;
    margin-right: 3px;
  }
  &-img-text {
    font-size: 14px;
    color: @c-color-primary;
  }
}
/deep/.field {
  padding: 0;
  .van-field__body {
    background-color: #f6f6f6;
    width: 235px;
    padding: 6px 15px;
    box-sizing: border-box;
    border-radius: 4px;
  }
}
.margin-bottom {
  margin-bottom: 13px;
  border-bottom: 0.01333rem solid #e9e9e9;
}
.flex-align-center {
  align-items: center;
}
.button {
  width: 345px;
  height: 50px;
  border-radius: 25px;
  background-color: #fff;
  opacity: 0.83;
  color: @c-color-primary;
  font-weight: bold;
  font-size: 17px;
  margin-top: 15px;
  float: left;
}
</style>
